"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import Conditional from "@repo/shared-ui/Conditional";
import {
  selectIsAuthPending,
  selectIsAuthSuccessOrPerpetual,
  selectIsCommonSsoModalVisible,
  useAppSelector,
} from "@repo/web-store";
import { handleHeaderSignInClickDL } from "./HeaderAnalyticsFunction";
import {
  LOGGED_IN_MY_ACC_URL,
  NON_LOGGED_IN_MY_ACC_URL,
} from "../../constants/HeaderConstants";
import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";
import dynamic from "next/dynamic";
import BFLModal from "@repo/shared-ui/BFLModal";
import { memo } from "react";
import FirstName from "./FirstName";

interface HeaderSignInProps {
  headerSignIn?: {
    heading: string;
    key: string;
    loggedInGreeting: string;
    loggedInGreetingWithoutName: string;
    myAccountLoggedInUrl: string;
    myAccountNonLoggedInUrl: string;
    sectionID: string;
    showOnApp: string;
    showOnWeb: string;
    template: string;
  };
}

/**
 * LoginModalContent
 */
const LoginModalContent: any = dynamic(
  () => import("../Login/LoginModalContent.tsx").then((m) => m.default),
  {
    ssr: false,
    loading: () => (
      <BFLModal title="" isOpen={true} onClose={() => {}}>
        <BFLSkeleton height={80} count={3} />{" "}
      </BFLModal>
    ),
  },
);

const MemoizedLoginModalContent = memo(LoginModalContent);

const SignIn: React.FC<HeaderSignInProps> = ({ headerSignIn }) => {
  const isAuthSuccessOrPerpetual = useAppSelector(
    selectIsAuthSuccessOrPerpetual,
  );

  const isAuthPending = useAppSelector(selectIsAuthPending);
  const isCommonSsoModalVisible = useAppSelector(selectIsCommonSsoModalVisible);

  const signInLabel = headerSignIn?.heading ?? "Sign In";

  return (
    <>
      <div className={isAuthSuccessOrPerpetual ? "hidden md:block" : ""}>
        <BFLLink
          href={
            isAuthSuccessOrPerpetual
              ? LOGGED_IN_MY_ACC_URL
              : (headerSignIn?.myAccountNonLoggedInUrl ??
                NON_LOGGED_IN_MY_ACC_URL)
          }
          onClick={() => handleHeaderSignInClickDL("Header sign in icon")}
          className="order-1 mx-1 flex flex-row-reverse items-center gap-1 px-0 pb-[30px] pt-[14px] hover:bg-[#001326] md:order-1 md:mx-2 md:flex md:!flex-col md:!gap-0"
        >
          <i className="icomoon hidden text-2xl before:content-['\e954'] md:block"></i>
          <span className="relative whitespace-nowrap text-xs leading-[14px] after:ml-[4px] after:inline-flex md:after:hidden">
            <div className="hidden md:block">
              <Conditional if={isAuthPending}>
                <BFLSkeleton
                  count={1}
                  height={14}
                  width={40}
                  borderRadius={0}
                />
              </Conditional>
            </div>

            <Conditional if={!isAuthPending}>
              <>
                <Conditional if={!isAuthSuccessOrPerpetual}>
                  <>{signInLabel}</>
                </Conditional>
                <Conditional if={isAuthSuccessOrPerpetual}>
                  <FirstName />
                </Conditional>
              </>
            </Conditional>
          </span>
          <i className="icomoon text-[6px] before:content-['\e911'] md:hidden"></i>
          <i className="icomoon text-2xl before:content-['\e954'] md:hidden"></i>
        </BFLLink>
      </div>

      <Conditional if={isCommonSsoModalVisible}>
        <MemoizedLoginModalContent />
      </Conditional>
    </>
  );
};
export default SignIn;
